import { render, staticRenderFns } from "./CrearTipoMedidaModal.vue?vue&type=template&id=2707f5a2&"
import script from "./CrearTipoMedidaModal.vue?vue&type=script&lang=ts&"
export * from "./CrearTipoMedidaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports